import React, { useReducer, useEffect } from 'react';
import { useSpring, animated } from 'react-spring';
import useWindowWidth from 'shared/hooks/useWindowWidth';
import styles from './Testimonials.mod.scss';
import { ExtraWideContainer } from 'scy/layouts';
import { LightBackground } from 'scy/Background';
import { Paragraph, H5 } from 'scy/text';
import { uppercase, accent } from 'scy/text/styles.mod.scss';
import { SecondaryButton } from 'scy/buttons';
import MixingIcon from 'images/icons/logos/mixing.svg?react-svg';
import LeftArrow from 'images/icons/controls/chevron-left-large.svg?react-svg';
import RightArrow from 'images/icons/controls/chevron-right-large.svg?react-svg';
import Kelly from 'images/landing-page/kelly.png';
import Dalia from 'images/landing-page/dalia.png';
import Vincent from 'images/landing-page/vincent.png';
import Will from 'images/landing-page/will.png';
import John from 'images/landing-page/john.png';

const LIST = [
  {
    quote:
      'Honestly I initially used Saucey simply because I love the idea of alcohol delivered to my door… The last time I used Saucey I got awesome bourbon with ginger ale and lime (for the hubs, I drink it straight) for less than I could have paid at the store, even including tip. DAMN!',
    author: 'Kelly F.',
    photo: Kelly
  },
  {
    quote:
      'This app is A GAME CHANGER!! Works flawlessly, easy to order! I ordered something as small as cider and arrived in 22 min!',
    author: 'Dalia R.',
    photo: Dalia
  },
  {
    quote:
      'Saucey has literally become a lifestyle changer for me. I’m often way too busy or burnt out after work to want to go back out for booze when I realize my fridge is empty and I need a well earned beer. Enter Saucey.',
    author: 'Vincent R.',
    photo: Vincent
  },
  {
    quote:
      'The only way I get my beer now! They have a pretty solid selection. Haven’t been to the liquor store in months.',
    author: 'Will S.',
    photo: Will
  },
  {
    quote:
      'Entertaining is way easier. I don’t have to leave the party to replenish the well, so I get more time with my friends and my buzz.',
    author: 'John L.',
    photo: John
  }
];

const init = { active: 0, next: 1, prev: LIST.length - 1, autoplay: true };

function reducer(state, action) {
  switch (action) {
    case 'next':
      return {
        ...state,
        active: modAdd(state.active, 1, LIST.length),
        next: modAdd(state.next, 1, LIST.length),
        prev: modAdd(state.prev, 1, LIST.length)
      };
    case 'prev':
      return {
        ...state,
        active: modAdd(state.active, -1, LIST.length),
        next: modAdd(state.next, -1, LIST.length),
        prev: modAdd(state.prev, -1, LIST.length)
      };
    case 'pause':
      return { ...state, autoplay: false };
    case 'play':
      return { ...state, autoplay: true };
    default:
      return state;
  }
}

function modAdd(a, b, mod) {
  return (mod + a + b) % mod;
}

export default function Testimonials() {
  const [state, dispatch] = useReducer(reducer, init);
  const { active, prev, next, autoplay } = state;

  useEffect(() => {
    if (autoplay) {
      const timer = setTimeout(() => dispatch('next'), 5000);
      return () => clearTimeout(timer);
    }
  }, [active, autoplay]);

  const windowWidth = useWindowWidth();

  return (
    <ExtraWideContainer className={styles.container}>
      <SecondaryButton
        noBorder
        className={styles.leftArrow}
        onClick={() => dispatch('prev')}
      >
        <LeftArrow />
      </SecondaryButton>
      <ul
        className={styles.list}
        onMouseOver={() => dispatch('pause')}
        onMouseOut={() => dispatch('play')}
      >
        {LIST.map((item, idx) => (
          <Testimonial
            key={idx}
            isActive={idx === active}
            isPrev={idx === prev}
            isNext={idx === next}
            xOffsetPercentage={
              windowWidth >= 1350 ? 64 : windowWidth >= 1024 ? 45 : 20
            }
            {...item}
          />
        ))}
      </ul>
      <SecondaryButton
        noBorder
        className={styles.rightArrow}
        onClick={() => dispatch('next')}
      >
        <RightArrow />
      </SecondaryButton>
    </ExtraWideContainer>
  );
}

function Testimonial({
  isActive,
  isPrev,
  isNext,
  quote,
  author,
  photo,
  xOffsetPercentage
}) {
  const x = isPrev ? -xOffsetPercentage : isNext ? xOffsetPercentage : 0;
  const z = isActive ? 0 : isPrev || isNext ? -50 : -100;
  const { transform, maxHeight, opacity, zIndex } = useSpring({
    transform: `perspective(250px) translateX(${x}%) translateZ(${z}px)`,
    maxHeight: isActive ? 500 : 100,
    opacity: isActive ? 1 : 0,
    zIndex: isActive ? 2 : isPrev ? 0 : isNext ? 1 : -1
  });

  return (
    <LightBackground
      tag={animated.li}
      className={styles.card}
      style={{
        transform,
        zIndex: zIndex.interpolate(z => Math.round(z))
      }}
    >
      <animated.blockquote className={styles.quote}>
        <Paragraph tag={animated.p} style={{ maxHeight, overflow: 'hidden' }}>
          “{quote}”
        </Paragraph>
        <animated.footer className={styles.footer} style={{ opacity }}>
          <img src={photo} className={styles.photo} />
          <div className={accent}>
            <MixingIcon width={19} height={39} />
          </div>
          <H5 tag="div" className={uppercase}>
            {author}
          </H5>
        </animated.footer>
      </animated.blockquote>
    </LightBackground>
  );
}
